import api from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Download } from 'lucide-react';
import { toast } from 'sonner';

const downloadBlob = (content, filename, type) => {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};

export const ExportDataCard = () => {
  const handleExportJSON = async () => {
    try {
      const response = await api.get('/export/json');
      downloadBlob(JSON.stringify(response.data, null, 2), 'brioritizer_export.json', 'application/json');
      toast.success('Data exported as JSON');
    } catch { toast.error('Export failed'); }
  };

  const handleExportCSV = async () => {
    try {
      const response = await api.get('/export/csv');
      downloadBlob(response.data, 'brioritizer_export.csv', 'text/csv');
      toast.success('Data exported as CSV');
    } catch { toast.error('Export failed'); }
  };

  return (
    <Card className="glass border-white/20 dark:border-white/10">
      <CardHeader>
        <CardTitle className="font-['Manrope'] flex items-center gap-2">
          <Download className="w-5 h-5" /> Export Data
        </CardTitle>
        <CardDescription>Download your data for backup or portability</CardDescription>
      </CardHeader>
      <CardContent className="flex gap-4">
        <Button variant="outline" onClick={handleExportJSON} data-testid="export-json-btn">Export JSON</Button>
        <Button variant="outline" onClick={handleExportCSV} data-testid="export-csv-btn">Export CSV</Button>
      </CardContent>
    </Card>
  );
};
